import useAuthorisedEntities from "./useAuthorisedEntities";
import useLpAccessRights from "./useLpAccessRights";
export function useTermAccessRights(termKey) {
    var authorizedEntities = useAuthorisedEntities();
    var ref = useLpAccessRights(), hasAccessRights = ref.hasAccessRights, hasAdminRights = ref.hasAdminRights;
    if (!termKey) return [];
    var ref1;
    if (hasAccessRights || hasAdminRights) return (ref1 = authorizedEntities === null || authorizedEntities === void 0 ? void 0 : authorizedEntities[termKey]) !== null && ref1 !== void 0 ? ref1 : [];
    return [];
}
export default useTermAccessRights;

//# sourceMappingURL=useTermAccessRights.js.map